import React from 'react'
import { SitesList } from '../../company/components/SitesList'

const CompanySites = ({ companyId }: { companyId: number }) => {
  return <SitesList companyId={companyId} location={'overview'} />
}

export default CompanySites
